import React from 'react'

import {
    WideScreenContainer
} from 'components/elements'

import PurpleAnimHeader from 'components/PurpleAnimHeader';
// import ViewAll from 'components/ViewAll';

// import {r3cPageContent} from 'constants/index'
import NewsletterSignup from 'components/NewsletterSignup';
// import {findContent, getImageDimensions, isEmptyObject} from 'generalHelpers'

import FooterAnimation from 'components/FooterAnimation'
import LearnAboutOtherNewsletters from 'components/LearnAboutOtherNewsletters';
import { NewslettersPageWrap } from '../elements';
// import useRememberScrollPosition from 'hooks/useRememberScrollPosition';
import LoadingHoc from 'hoc/LoadingHOC';


function MonthlyDigestSignup(props) {

	const {setLoading} = props		 //receive the loading trigger change function from the HOC
	
	React.useEffect(() => {
			setLoading(false)

		// eslint-disable-next-line
	}, [])

	// useRememberScrollPosition('monthly-digest')
	
	return (
		<NewslettersPageWrap className="pageWrapper">

			<PurpleAnimHeader
                sectionLabel={"The Healthcare Connection"}
                sectionTitle={undefined}
				heroIntro={undefined}
				headerSplit={"1"}
                backgroundImage={"/images/monthly-digest-header-dsktop.png"}
				backgroundImgMbl={"/images/monthly-digest-header-mbl.png"}
				backgroundImgTitle={""}
                header={"Transformative ideas delivered monthly"}
				headerMaxWidth={"60%"}
				introCopy={"Once a month, we bring you a round-up of the people, stories and ideas that are changing healthcare into what it should be."}
                titleMdPadding={"15% 0 0"}
				maxWidth={"25%"}
				marginRight={"15%"}
                maxHeight={"600px"}

            />




			<WideScreenContainer>
				<NewsletterSignup
                    phoneDesktop={"/images/monthly-digest-phone.png"}
                    phoneMobile={"/images/monthly-digest-phone.png"}
					pardotLink={"https://go.realchemistry.com/l/603341/2022-11-11/691jm"}

				/>

				<LearnAboutOtherNewsletters
				  monthly={false}
				  healthEquity={true}
				  valueReport={true}
				  displayHeader={true}
				/>

			</WideScreenContainer>

			<FooterAnimation
				svgDesktop="/images/purple-footer.svg"
				svgMobile="/images/purple-footer-mbl.svg"
				borderTop="none"
			/>
		</NewslettersPageWrap>
	)
}


export default LoadingHoc(MonthlyDigestSignup);
